"use client";

import ComingSoonClient from "@/app/coming-soon/ComingSoonClient";

export default function LogisticsPage() {
  return <ComingSoonClient />;
}


